import { defineStore } from 'pinia';
import type { BaseModule, ModulesSettingsApi } from "@haxo-cz/tsoa-ts-client";
import app from "@/main";
import { useAppStore } from "@/stores/appStore";

export interface ModuleState {
    modules: BaseModule[]; // Moduly pro aktuální projekt
    moduleSettingsApi: ModulesSettingsApi | null; // Přidali jsme možnost, že API může být null před inicializací
}
// Funkce, která vrací instanci ModulesSettingsApi, ale může trvat nějakou dobu, než se inicializuje
// Protože se inicializuje až po přihlášení uživatele
async function getModulesSettingsApi(): Promise<ModulesSettingsApi> {
    return new Promise((resolve, reject) => {
        const interval = setInterval(() => {
            const api = app.config.globalProperties.$modulesSettingsApi;
            if (api) {
                clearInterval(interval);
                resolve(api);
            }
        }, 50);

        setTimeout(() => {
            clearInterval(interval);
            reject(new Error("ModulesSettingsApi is not available within the expected time."));
        }, 5000); // Nastavíme maximální čekací dobu 5 sekund
    });
}

export const useModuleStore = defineStore('moduleStore', {
    state: (): ModuleState => ({
        modules: []

    }),

    actions: {

        async fetchModules(spaceId: string, projectId: string, includeSettings: boolean = true): void {
            try {
                const moduleSettingsApi = await getModulesSettingsApi(); // Počkáme na inicializaci API
                const response = await moduleSettingsApi.findAllModules(spaceId, projectId);
                const modules = response.data;

                if (!includeSettings) {
                    modules.forEach((module: BaseModule) => {
                        delete module.projectSettings;
                    });
                }
                this.modules = modules;

            } catch (error) {
                console.error("Error fetching modules:", error);
                return [];
            }
        },

        clearModules() {
            this.modules = [];
        },
        resetStore() {
            this.$reset();
        }
    }

});
